<template>
  <div class="bootstrap-wrapper main Bgc-white">
    <Header /> 
    <div class="container">
      <div class="row mt-lg-5 mt-0 error-container">
        <div class="col-lg-12 body p-0 error-container__content">
          <figure class="logo-error">
            <img src="./../../../assets/img/posadas-corporate.svg" alt="Corporate">
          </figure>
          <figure class="error-img">
            <img src="./../../../assets/img/error.svg">
          </figure>

          <div class="error-text-container">
            <p>
                {{$t('language.posadasCorporate.errorPage.mainPaPartOne')}}
               <a class="link" href="mailto:soportecorporate@posadas.com">soportecorporate@posadas.com</a>. 
               {{$t('language.posadasCorporate.errorPage.mainPaPartTwo')}}
            </p>
            

                  <div class="col-lg-4">
                  <ul class="list-group list-group-footer">
                  <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-telephone"> </i> 
                        {{$t('language.posadasCorporate.footer.mexico')}}: <a class="cta-footer" href="tel:4432982253">44 3298 2253</a>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-telephone"> </i> 
                        {{$t('language.posadasCorporate.footer.usa')}}: <a class="cta-footer" href="tel:18552636094">1 855 26 36 094</a>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-whatsapp"> </i> 
                        <a class="cta-footer" v-on:click="perfection1000" onclick="return false;" href="#">44 3137 8728</a>
                      </p>
                    </li>
                    <li class=""> 
                      <p class="notas mb-3">
                        <i class="demo-icon icon-chat"> </i> 
                        <a class="cta-footer" v-on:click="perfection3" onclick="return false;" href="#">{{$t('language.posadasCorporate.footer.chat')}}</a>
                      </p>
                    </li>
                  </ul>
                </div>


            <p>{{$t('language.posadasCorporate.errorPage.secondPa')}}.</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>


<script>
  import SecureLS from 'secure-ls';
  import Header from "../../generales/Header.vue";
  import Footer from "../../generales/Footer.vue";
  export default {
    name: 'Error',
    components: {
      Header,
      Footer,
    },
    data: () => {
      return {
        language: '',
        ls: new SecureLS({ encodingType: "aes" }),
      }
    },
    methods: {
       perfection3() {
            var ls = new SecureLS({encodingType: 'aes'});
            this.language = ls.get('Language'); 
              if( this.language.data == 'es' && this.language.data != '' ) {
                window.open(process.env.VUE_APP_CHATES, '_blank');
              } else {
                window.open(process.env.VUE_APP_CHATEN, '_blank');
              }
        },
      perfection1000() {
            window.open(process.env.VUE_APP_WHATSAPP, '_blank');

    },  
    }
  };
</script>

<style lang="scss" scoped>
  @import './../../../assets/scss/config.scss';
  .error-container {
    margin-bottom: 70px;
    padding-top: 50px;
  }
  .error-container__content {
    display: flex;
    flex-direction: column
  }
  .logo-error {
    margin: 0 auto;
    margin-top: 56px;
    margin-bottom: 32px;
    img {
      width: 209px;
    }
  }
  .error-img {
    img {
      width: 100%;
    }
  }
  .error-text-container {
    // width: 90%;
    padding: 0 72px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 50px;
    @media (max-width: 600px) {
      padding: 0 24px;
    }
  }
</style>